import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Ticket deep link: /go/t/:token → /login?ticket=:token
 * Token should be ticket_number (barcode) or Tezam Identifier — not Cabex payment GUID
 * unless it is confirmed equal to event_tickets.external_id.
 */
export function TicketInvitePage() {
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const code = (token || "").trim();
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }
    navigate(`/login?ticket=${encodeURIComponent(code)}`, { replace: true });
  }, [token, navigate]);

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center p-6 text-center gap-3">
      <Loader2 size={28} className="animate-spin text-indigo-600" />
      <p className="text-[14px] text-gray-600">{t("visitor.ticket_invite_redirect")}</p>
    </div>
  );
}
